import { OrganizationModel, ContactModel, OrganizationItemModel, NotificationSettingsModel } from '.';
export default class RegistrationModel {
  firstName: string;
  lastName: string;
  prefix: string;
  title: string;
  email: string;
  community: string;
  confirmEmail: string;
  password: string;
  confirmPassword: string;
  organizationIds: OrganizationItemModel[];
  newOrganization?: OrganizationModel;
  contact: ContactModel;
  notificationSettings: NotificationSettingsModel;

  constructor(data?: any) {
    this.firstName = data?.firstName || undefined;
    this.lastName = data?.lastName || undefined;
    this.prefix = data?.prefix || undefined;
    this.title = data?.title || undefined;
    this.email = data?.email || undefined;
    this.community = data?.community || undefined;
    this.confirmEmail = data?.confirmEmail || undefined;
    this.password = data?.password || undefined;
    this.confirmPassword = data?.confirmPassword || undefined;
    this.contact = new ContactModel(data?.contact || {});
    this.organizationIds = data?.organizationIds || [];
    this.newOrganization = data?.newOrganization ? new OrganizationModel(data.newOrganization) : undefined;
    this.notificationSettings = new NotificationSettingsModel(data?.notificationSettings || {});
  }
}
